import React, { Component } from 'react';
import { WithStyles, withStyles } from '@mui/styles';
import APReferralsSearchBarStyle from './styles/APReferralsSearchBar.style';
import { ReactComponent as ReferralSearchIcon } from './assets/searchIcon.svg';

interface APReferralsSearchBarProps extends WithStyles<typeof APReferralsSearchBarStyle> {
    className?: string,
    onSearchClick: Function
}

class APReferralsSearchBar extends Component<APReferralsSearchBarProps, {}> {
    render() {

        const { classes, onSearchClick } = this.props;

        return (
            <div className={classes.root}>
                <ReferralSearchIcon data-testid="search-input" className={classes.searchIcon} onClick={(e)=>{onSearchClick(e)}}/>
            </div>
        );
    }
}

export default withStyles(APReferralsSearchBarStyle)(APReferralsSearchBar);